import { renderNumberOfSelections } from "metabase/parameters/utils/formatting";
import { getSharedRemappedField } from "metabase-lib/v1/metadata/utils/remapping";
import type { ParameterField } from "metabase-lib/v1/parameters/types";
import { hasRemappedParameterValues } from "metabase-lib/v1/parameters/utils/parameter-source";
import type { CardId, DashboardId, Parameter } from "metabase-types/api";

import { Value } from "../Value";
import { normalizeValue } from "../normalizeValue";

type ParameterFieldWidgetValueProps = {
  value: unknown;
  fields: ParameterField[];
  parameter?: Parameter;
  cardId?: CardId;
  dashboardId?: DashboardId;
  displayValue?: string;
};

export function ParameterFieldWidgetValue({
  value,
  fields,
  parameter,
  cardId,
  dashboardId,
  displayValue,
}: ParameterFieldWidgetValueProps) {
  const values = normalizeValue(value);
  const numberOfValues = values.length;
  const shouldRemap =
    (parameter != null
      ? hasRemappedParameterValues(parameter, fields)
      : getSharedRemappedField(fields) != null) || displayValue != null;

  return numberOfValues > 1 ? (
    <>{renderNumberOfSelections(numberOfValues)}</>
  ) : (
    <Value
      remap={shouldRemap}
      value={values[0]}
      column={fields[0]}
      parameter={parameter}
      cardId={cardId}
      dashboardId={dashboardId}
      displayValue={displayValue}
    />
  );
}
